export default "__VITE_ASSET__4b8d1532__"